// extracted by mini-css-extract-plugin
export var textInput = "_ck-0";